import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Transform } from '@atlaskit/editor-prosemirror/transform';
export var createDiffTransformation = function createDiffTransformation(docFrom, diffObjects, actions) {
  var transform = new Transform(docFrom);
  var onAddition = actions.onAddition,
    onDeletion = actions.onDeletion,
    onReplacement = actions.onReplacement;
  diffObjects.forEach(function (diff) {
    var mappedTo = transform.mapping.map(diff.to);
    var mappedFrom = Math.min(transform.mapping.map(diff.from), transform.doc.content.size, mappedTo);
    var params = _objectSpread(_objectSpread({}, diff), {}, {
      transform: transform,
      from: mappedFrom,
      to: mappedTo
    });
    switch (diff.type) {
      case 'ADDITION':
        onAddition(params);
        break;
      case 'DELETION':
        onDeletion(params);
        break;
      case 'REPLACEMENT':
        onReplacement(params);
        break;
    }
  });
  return transform;
};